/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import BaseModel from 'js-sdk/src/common/model/BaseModel';
import logger from "js-sdk/src/common/logging/logger";

let localLogger = logger.register("InputControlOptionModel");

export default BaseModel.extend({
    defaults: {
        selected: false,
        label: undefined,
        value: undefined
    },
    initialize: function () {
        this.on('all', localLogger.debug, localLogger);
    }
});